module.exports = __webpack_public_path__ + "img/de_dust2.fb0f462c.jpg";